import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';

import { SettingService } from '@app/services/setting.service';
import { ElectronZoomComponent } from '@app/shared/electron-zoom/electron-zoom.component';
import { isElectronDirective } from '@app/shared/is-electron.directive';
import { IsOnlineStatusComponent } from '@app/shared/is-online-status/is-online-status.component';
import { PdoModeStatusComponent } from '@app/shared/pdo-mode-status/pdo-mode-status.component';
import { ReleaseVersionComponent } from '@app/shared/release-version.component';

@Component({
  selector: 'app-main-statusbar',
  templateUrl: './main-statusbar.component.html',
  imports: [
    IsOnlineStatusComponent,
    PdoModeStatusComponent,
    ReleaseVersionComponent,
    isElectronDirective,
    ElectronZoomComponent,
    AsyncPipe,
  ],
})
export class MainStatusbarComponent {
  private settingService = inject(SettingService);

  modeEnabled$ = this.settingService.modeEnabled$;
  modeText$ = this.settingService.modeText$;
}
